window.addEventListener("DOMContentLoaded", () => {
  class pqDealerAdvantage extends HTMLElement {
    constructor() {
      super();
      // 初始化元素引用
    }

    connectedCallback() {
      this.initSwiper();
    }

    initSwiper() {
      let swiperDom = this.querySelector(".swiper");
      let swiperScrollbar = this.querySelector(".swiper-scrollbar");
      var swiper = new Swiper(swiperDom, {
        spaceBetween: 16,
        scrollbar: {
          el: swiperScrollbar,
          draggable: true,
        },
      });
    }
  }

  // 注册自定义元素
  customElements.define("pq-dealer-advantage", pqDealerAdvantage);
});
